<template>
    <div class="customfields-group">
        <el-checkbox
            :data-bot="getDatabot('checkbox', currentStore, null, 'cf-popup')"
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            class="mb-2 bold lh-20">{{ groupName }}</el-checkbox>
        <el-checkbox-group 
            v-model="fieldsChecked"
            @change="handleCheckedFieldsChange"
            class="flex-column">
            <el-checkbox
                :data-bot="getDatabot('checkbox', currentStore, null, 'cf-popup')"
                v-for="(field, index) in group.fields"
                :class="{'mb-2': index !== group.fields.length - 1}"
                class="lh-20 regular"
                :label="field.id"
                :key="field.id"
                :disabled="field.mandatory"
                :checked="isChecked(field)">
                    {{ field.name }}
            </el-checkbox>
        </el-checkbox-group>
    </div>
</template>

<script>
import DataBotsFormsMixins from "mixins/DataBotsFormsMixins";

export default {
    mixins: [DataBotsFormsMixins],
    props: {
        group: {
            type: Object,
            required: true
        },
        currentStore: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isIndeterminate: false,
            checkAll: false,
            fieldsChecked: []
        }
    },
    computed: {
        activeCustomFields(){
            return this.$store.getters[`${this.currentStore}/customFields`].map(field => field.id);
        },
        groupName() {
            return !!this.group.name ? this.group.name : this.$l10n.__('Aucune catégorie');
        },
        requiredFields() {
            return this.group.fields.filter(field => field.mandatory);
        }
    },
    methods: {
        isChecked(field){
            return(field.mandatory || this.activeCustomFields.includes(field.id))
        },
        handleCheckAllChange(val) {
            this.fieldsChecked = val ? this.group.fields.map(field => field.id) : this.requiredFields.map(field => field.id);
            this.isIndeterminate = false;
            this.updateFields();
        },
        handleCheckedFieldsChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.group.fields.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.group.fields.length;
            this.updateFields();
        },
        updateFields() {
            this.$emit('fieldsUpdated', { id: this.group.id, fields: this.group.fields.filter(field => this.fieldsChecked.includes(field.id) && !field.mandatory) });
        }
    }
}
</script>

<style lang="scss">
    .customfields-group {
        .el-checkbox {
            &:not(.bold) {
                font-weight: 400;
            }
            .el-checkbox__label {
                line-height: 20px;
            }
        }
    }
</style>